import { render, staticRenderFns } from "./EiShippingTemplate.vue?vue&type=template&id=f3d6a89a&scoped=true&"
import script from "./EiShippingTemplate.vue?vue&type=script&lang=js&"
export * from "./EiShippingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EiShippingTemplate.vue?vue&type=style&index=0&id=f3d6a89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d6a89a",
  null
  
)

component.options.__file = "EiShippingTemplate.vue"
export default component.exports